// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ChatBackupPage styles
 * Following patterns from AutoLogoutPage.css and DeveloperInfoPage.css
 */

.chat-backup-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.chat-backup-page .settings-modal-header {
  position: relative;
  justify-content: center;
}

.chat-backup-page .back-button {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.chat-backup-content {
  padding: 24px;
  flex-grow: 1;
  overflow-y: auto;
}

/* Loading state */
.chat-backup-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 16px;
  color: #6b7280;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e5e7eb;
  border-top-color: var(--netsfere-red, #cc4b5c);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Create backup state (State A) */
.chat-backup-create {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.chat-backup-description {
  color: #374151;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 100%;
  margin: 0;
}

/* Recovery key display box */
.recovery-key-display-box {
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
}

.recovery-key-code {
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 100%;
  word-break: break-all;
  color: #1f2937;
  user-select: all;
  letter-spacing: 0;
}

/* Activation section - save key options */
.activation-section {
  padding: 0;
}

.activation-section-heading {
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.activation-section-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #6b7280;
  margin: 0 0 20px 0;
}

/* Two-button activation layout */
.activation-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.activation-buttons .chat-backup-btn {
  flex: 1;
  min-width: 180px;
  gap: 8px;
  font-weight: 600;
  padding: 14px 20px;
}

.activation-buttons .chat-backup-btn ion-icon {
  font-size: 18px;
  flex-shrink: 0;
}

/* Outline button variant */
.chat-backup-btn-outline {
  background-color: transparent;
  color: var(--netsfere-red, #cc4b5c);
  border: 2px solid var(--netsfere-red, #cc4b5c);
}

.chat-backup-btn-outline:hover:not(:disabled) {
  background-color: rgba(204, 75, 92, 0.08);
}

.chat-backup-btn-outline:active:not(:disabled) {
  background-color: rgba(204, 75, 92, 0.15);
}

/* Legacy copy-link styles (kept for backwards compatibility) */
.copy-section {
  padding: 0;
}

.copy-section-heading {
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 100%;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.copy-section-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 100%;
  color: #6b7280;
  margin: 0 0 12px 0;
}

.copy-link {
  background: none;
  border: none;
  color: var(--netsfere-red, #cc4b5c);
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  cursor: pointer;
  padding: 0;
  text-decoration: none;
}

.copy-link:hover:not(:disabled) {
  text-decoration: underline;
}

.copy-link:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Activation note */
.activation-note {
  background-color: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 100%;
  color: #92400e;
}

.activation-note.success {
  background-color: #d1fae5;
  border-color: #10b981;
  color: #065f46;
}

.activation-note strong {
  font-weight: 600;
}

/* Activation progress */
.activation-progress {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background-color: #f3f4f6;
  border-radius: 8px;
  color: #6b7280;
  font-size: 14px;
}

.activation-progress .loading-spinner {
  width: 20px;
  height: 20px;
  border-width: 2px;
}

/* Activation error */
.activation-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #dc2626;
  font-size: 14px;
}

.activation-error ion-icon {
  font-size: 18px;
  flex-shrink: 0;
}

/* Active backup state (State B) */
.chat-backup-active {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0;
}

.chat-backup-success-icon {
  font-size: 56px;
  color: #10b981;
  margin-bottom: 12px;
}

.chat-backup-success-icon ion-icon {
  font-size: inherit;
}

.chat-backup-success-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 20px 0;
}

.chat-backup-success-message {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 32px 0;
  max-width: 300px;
  line-height: 1.5;
}

/* Action buttons */
.chat-backup-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 280px;
}

.chat-backup-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, opacity 0.2s ease;
  border: none;
  min-width: 200px;
}

.chat-backup-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chat-backup-btn-primary {
  background-color: var(--netsfere-red, #cc4b5c);
  color: white;
}

.chat-backup-btn-primary:hover:not(:disabled) {
  background-color: rgb(195, 60, 75);
}

.chat-backup-btn-secondary {
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}

.chat-backup-btn-secondary:hover:not(:disabled) {
  background-color: #e5e7eb;
}

/* Export note */
.chat-backup-export-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 16px;
  padding: 12px 16px;
  background-color: #f3f4f6;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
  text-align: left;
  max-width: 280px;
}

.chat-backup-export-note ion-icon {
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.activation-note.success {
  animation: fadeIn 0.3s ease-in;
}

/* ============================================
   MOTION & FEEDBACK ANIMATIONS
   ============================================ */

/* Keyframe: Slide in from below with fade */
@keyframes slideInFade {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Keyframe: Checkmark pop with bounce */
@keyframes checkmarkPop {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}

/* Keyframe: State container entrance */
@keyframes stateEnter {
  from {
    opacity: 0;
    transform: scale(0.97);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Keyframe: Success icon pop with spring */
@keyframes successIconPop {
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* State A: Staggered entrance animations */
.chat-backup-create.animate-in .chat-backup-description {
  animation: slideInFade 0.4s ease-out forwards;
  animation-delay: 0ms;
  opacity: 0;
}

.chat-backup-create.animate-in .recovery-key-display-box {
  animation: slideInFade 0.4s ease-out forwards;
  animation-delay: 100ms;
  opacity: 0;
}

.chat-backup-create.animate-in .activation-section-heading {
  animation: slideInFade 0.4s ease-out forwards;
  animation-delay: 200ms;
  opacity: 0;
}

.chat-backup-create.animate-in .activation-section-text {
  animation: slideInFade 0.4s ease-out forwards;
  animation-delay: 250ms;
  opacity: 0;
}

.chat-backup-create.animate-in .activation-buttons {
  animation: slideInFade 0.4s ease-out forwards;
  animation-delay: 350ms;
  opacity: 0;
}

.chat-backup-create.animate-in .activation-note {
  animation: slideInFade 0.4s ease-out forwards;
  animation-delay: 450ms;
  opacity: 0;
}

/* Copy button: success state */
.chat-backup-btn-primary {
  position: relative;
  overflow: hidden;
}

.chat-backup-btn-primary.copy-success {
  background-color: #10b981;
  pointer-events: none;
}

.chat-backup-btn-primary.copy-success:hover {
  background-color: #10b981;
}

.chat-backup-btn-primary.copy-success ion-icon {
  animation: checkmarkPop 0.3s ease-out;
}

/* State B: Entrance animations */
.chat-backup-active {
  animation: stateEnter 0.35s ease-out;
}

.chat-backup-active .chat-backup-success-icon {
  animation: successIconPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s forwards;
  opacity: 0;
  transform: scale(0);
}

.chat-backup-active .chat-backup-success-title {
  animation: slideInFade 0.4s ease-out 0.3s forwards;
  opacity: 0;
}

.chat-backup-active .chat-backup-actions {
  animation: slideInFade 0.4s ease-out 0.5s forwards;
  opacity: 0;
}

.chat-backup-active .chat-backup-export-note {
  animation: slideInFade 0.4s ease-out 0.6s forwards;
  opacity: 0;
}

/* Accessibility: Respect reduced motion preference */
@media (prefers-reduced-motion: reduce) {
  .chat-backup-create.animate-in .chat-backup-description,
  .chat-backup-create.animate-in .recovery-key-display-box,
  .chat-backup-create.animate-in .activation-section-heading,
  .chat-backup-create.animate-in .activation-section-text,
  .chat-backup-create.animate-in .activation-buttons,
  .chat-backup-create.animate-in .activation-note,
  .chat-backup-active,
  .chat-backup-active .chat-backup-success-icon,
  .chat-backup-active .chat-backup-success-title,
  .chat-backup-active .chat-backup-actions,
  .chat-backup-active .chat-backup-export-note,
  .chat-backup-btn-primary.copy-success ion-icon {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/ChatBackupPage.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,+DAA+D;AAC/D;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yDAAyD;EACzD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;iDAEiD;;AAEjD,4CAA4C;AAC5C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,2CAA2C;AAC3C;EACE,6CAA6C;EAC7C,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;AACtC;;AAEA;EACE,8EAA8E;EAC9E,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,kDAAkD;EAClD,UAAU;AACZ;;AAEA,qDAAqD;AACrD;EACE;;;;;;;;;;;;IAYE,0BAA0B;IAC1B,qBAAqB;IACrB,0BAA0B;EAC5B;AACF","sourcesContent":["/**\n * ChatBackupPage styles\n * Following patterns from AutoLogoutPage.css and DeveloperInfoPage.css\n */\n\n.chat-backup-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n.chat-backup-page .settings-modal-header {\n  position: relative;\n  justify-content: center;\n}\n\n.chat-backup-page .back-button {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.chat-backup-content {\n  padding: 24px;\n  flex-grow: 1;\n  overflow-y: auto;\n}\n\n/* Loading state */\n.chat-backup-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  gap: 16px;\n  color: #6b7280;\n}\n\n.loading-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e5e7eb;\n  border-top-color: var(--netsfere-red, #cc4b5c);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Create backup state (State A) */\n.chat-backup-create {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.chat-backup-description {\n  color: #374151;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 100%;\n  margin: 0;\n}\n\n/* Recovery key display box */\n.recovery-key-display-box {\n  background-color: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n}\n\n.recovery-key-code {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 100%;\n  word-break: break-all;\n  color: #1f2937;\n  user-select: all;\n  letter-spacing: 0;\n}\n\n/* Activation section - save key options */\n.activation-section {\n  padding: 0;\n}\n\n.activation-section-heading {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.3;\n  color: #1f2937;\n  margin: 0 0 8px 0;\n}\n\n.activation-section-text {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #6b7280;\n  margin: 0 0 20px 0;\n}\n\n/* Two-button activation layout */\n.activation-buttons {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.activation-buttons .chat-backup-btn {\n  flex: 1;\n  min-width: 180px;\n  gap: 8px;\n  font-weight: 600;\n  padding: 14px 20px;\n}\n\n.activation-buttons .chat-backup-btn ion-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n/* Outline button variant */\n.chat-backup-btn-outline {\n  background-color: transparent;\n  color: var(--netsfere-red, #cc4b5c);\n  border: 2px solid var(--netsfere-red, #cc4b5c);\n}\n\n.chat-backup-btn-outline:hover:not(:disabled) {\n  background-color: rgba(204, 75, 92, 0.08);\n}\n\n.chat-backup-btn-outline:active:not(:disabled) {\n  background-color: rgba(204, 75, 92, 0.15);\n}\n\n/* Legacy copy-link styles (kept for backwards compatibility) */\n.copy-section {\n  padding: 0;\n}\n\n.copy-section-heading {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 100%;\n  color: #1f2937;\n  margin: 0 0 8px 0;\n}\n\n.copy-section-text {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 100%;\n  color: #6b7280;\n  margin: 0 0 12px 0;\n}\n\n.copy-link {\n  background: none;\n  border: none;\n  color: var(--netsfere-red, #cc4b5c);\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 100%;\n  cursor: pointer;\n  padding: 0;\n  text-decoration: none;\n}\n\n.copy-link:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.copy-link:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Activation note */\n.activation-note {\n  background-color: #fef3c7;\n  border: 1px solid #fbbf24;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 100%;\n  color: #92400e;\n}\n\n.activation-note.success {\n  background-color: #d1fae5;\n  border-color: #10b981;\n  color: #065f46;\n}\n\n.activation-note strong {\n  font-weight: 600;\n}\n\n/* Activation progress */\n.activation-progress {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background-color: #f3f4f6;\n  border-radius: 8px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.activation-progress .loading-spinner {\n  width: 20px;\n  height: 20px;\n  border-width: 2px;\n}\n\n/* Activation error */\n.activation-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  color: #dc2626;\n  font-size: 14px;\n}\n\n.activation-error ion-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n/* Active backup state (State B) */\n.chat-backup-active {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 0;\n}\n\n.chat-backup-success-icon {\n  font-size: 56px;\n  color: #10b981;\n  margin-bottom: 12px;\n}\n\n.chat-backup-success-icon ion-icon {\n  font-size: inherit;\n}\n\n.chat-backup-success-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 20px 0;\n}\n\n.chat-backup-success-message {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0 0 32px 0;\n  max-width: 300px;\n  line-height: 1.5;\n}\n\n/* Action buttons */\n.chat-backup-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  max-width: 280px;\n}\n\n.chat-backup-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease, opacity 0.2s ease;\n  border: none;\n  min-width: 200px;\n}\n\n.chat-backup-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.chat-backup-btn-primary {\n  background-color: var(--netsfere-red, #cc4b5c);\n  color: white;\n}\n\n.chat-backup-btn-primary:hover:not(:disabled) {\n  background-color: rgb(195, 60, 75);\n}\n\n.chat-backup-btn-secondary {\n  background-color: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.chat-backup-btn-secondary:hover:not(:disabled) {\n  background-color: #e5e7eb;\n}\n\n/* Export note */\n.chat-backup-export-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 12px 16px;\n  background-color: #f3f4f6;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #6b7280;\n  text-align: left;\n  max-width: 280px;\n}\n\n.chat-backup-export-note ion-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.activation-note.success {\n  animation: fadeIn 0.3s ease-in;\n}\n\n/* ============================================\n   MOTION & FEEDBACK ANIMATIONS\n   ============================================ */\n\n/* Keyframe: Slide in from below with fade */\n@keyframes slideInFade {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Keyframe: Checkmark pop with bounce */\n@keyframes checkmarkPop {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* Keyframe: State container entrance */\n@keyframes stateEnter {\n  from {\n    opacity: 0;\n    transform: scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Keyframe: Success icon pop with spring */\n@keyframes successIconPop {\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* State A: Staggered entrance animations */\n.chat-backup-create.animate-in .chat-backup-description {\n  animation: slideInFade 0.4s ease-out forwards;\n  animation-delay: 0ms;\n  opacity: 0;\n}\n\n.chat-backup-create.animate-in .recovery-key-display-box {\n  animation: slideInFade 0.4s ease-out forwards;\n  animation-delay: 100ms;\n  opacity: 0;\n}\n\n.chat-backup-create.animate-in .activation-section-heading {\n  animation: slideInFade 0.4s ease-out forwards;\n  animation-delay: 200ms;\n  opacity: 0;\n}\n\n.chat-backup-create.animate-in .activation-section-text {\n  animation: slideInFade 0.4s ease-out forwards;\n  animation-delay: 250ms;\n  opacity: 0;\n}\n\n.chat-backup-create.animate-in .activation-buttons {\n  animation: slideInFade 0.4s ease-out forwards;\n  animation-delay: 350ms;\n  opacity: 0;\n}\n\n.chat-backup-create.animate-in .activation-note {\n  animation: slideInFade 0.4s ease-out forwards;\n  animation-delay: 450ms;\n  opacity: 0;\n}\n\n/* Copy button: success state */\n.chat-backup-btn-primary {\n  position: relative;\n  overflow: hidden;\n}\n\n.chat-backup-btn-primary.copy-success {\n  background-color: #10b981;\n  pointer-events: none;\n}\n\n.chat-backup-btn-primary.copy-success:hover {\n  background-color: #10b981;\n}\n\n.chat-backup-btn-primary.copy-success ion-icon {\n  animation: checkmarkPop 0.3s ease-out;\n}\n\n/* State B: Entrance animations */\n.chat-backup-active {\n  animation: stateEnter 0.35s ease-out;\n}\n\n.chat-backup-active .chat-backup-success-icon {\n  animation: successIconPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s forwards;\n  opacity: 0;\n  transform: scale(0);\n}\n\n.chat-backup-active .chat-backup-success-title {\n  animation: slideInFade 0.4s ease-out 0.3s forwards;\n  opacity: 0;\n}\n\n.chat-backup-active .chat-backup-actions {\n  animation: slideInFade 0.4s ease-out 0.5s forwards;\n  opacity: 0;\n}\n\n.chat-backup-active .chat-backup-export-note {\n  animation: slideInFade 0.4s ease-out 0.6s forwards;\n  opacity: 0;\n}\n\n/* Accessibility: Respect reduced motion preference */\n@media (prefers-reduced-motion: reduce) {\n  .chat-backup-create.animate-in .chat-backup-description,\n  .chat-backup-create.animate-in .recovery-key-display-box,\n  .chat-backup-create.animate-in .activation-section-heading,\n  .chat-backup-create.animate-in .activation-section-text,\n  .chat-backup-create.animate-in .activation-buttons,\n  .chat-backup-create.animate-in .activation-note,\n  .chat-backup-active,\n  .chat-backup-active .chat-backup-success-icon,\n  .chat-backup-active .chat-backup-success-title,\n  .chat-backup-active .chat-backup-actions,\n  .chat-backup-active .chat-backup-export-note,\n  .chat-backup-btn-primary.copy-success ion-icon {\n    animation: none !important;\n    opacity: 1 !important;\n    transform: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
